// src/components/Assets/AssetExpenses/ExpenseCard.js
// Individual expense card component - Matches Android layout

import React from "react";
import { useTranslation } from "react-i18next";
import { FaCalendar, FaTools } from "react-icons/fa";
import PropTypes from "prop-types";
import { getCategoryLabel } from "../models";
import "./ExpenseStyles.css";

const ExpenseCard = ({ expense }) => {
  const [t, { language }] = useTranslation();

  // Extract payment and asset from backend response structure
  const payment = expense.payment || expense;
  const asset = expense.asset;

  // Format date for display
  const formatDate = (timestamp) => {
    if (!timestamp) return "-";
    const date = new Date(timestamp);
    return date.toLocaleDateString(language === "ar" ? "ar-EG" : "en-US", {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  };

  // Format currency value - Always use dot as decimal separator
  const formatCurrency = (value) => {
    if (!value) return "0.00";
    const formatted = parseFloat(value).toFixed(2);
    // Add thousand separators while keeping dot as decimal separator
    const parts = formatted.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  };

  return (
    <div className="expense-card">
      {/* Card Header - Shows category as title (matching Android) */}
      <div className="expense-card-header">
        <div className="expense-category-title">
          <h3>{payment.category ? getCategoryLabel(payment.category, language) : t("Expense")}</h3>
        </div>
        <div className="expense-value">
          <span className="value-amount expense-negative">
            - {formatCurrency(payment.amountPaid)}
          </span>
        </div>
      </div>

      {/* Card Body */}
      <div className="expense-card-body">
        {/* Date */}
        <div className="expense-info-row">
          <div className="info-icon">
            <FaCalendar />
          </div>
          <div className="info-content">
            <span className="info-value">{formatDate(payment.paymentDate)}</span>
          </div>
        </div>

        {/* Asset Name as Chip (matching Android) */}
        {asset && (
          <div className="expense-asset-chip">
            <FaTools /> {asset.name}
          </div>
        )}

        {/* Description/Details */}
        {payment.description && (
          <div className="expense-details">
            <p>{payment.description}</p>
          </div>
        )}
      </div>
    </div>
  );
};

// PropTypes validation
ExpenseCard.propTypes = {
  expense: PropTypes.shape({
    payment: PropTypes.shape({
      id: PropTypes.number,
      amountPaid: PropTypes.number.isRequired,
      paymentDate: PropTypes.number.isRequired,
      category: PropTypes.string,
      description: PropTypes.string,
      assetId: PropTypes.number
    }),
    asset: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      details: PropTypes.string
    })
  }).isRequired
};

export default ExpenseCard;
